export default __webpack_public_path__ + "static/media/NC.0c3b2f03.svg";